"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DataQualityDetailGroup = void 0;
var react_1 = __importDefault(require("react"));
var DataQualityStyles_1 = require("../style/DataQualityStyles");
var DataQualityDetail_1 = require("./DataQualityDetail");
/**
 * @deprecated TFS-1478812
*/
function DataQualityDetailGroup(props) {
    if (props.details.length > 0) {
        return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(DataQualityStyles_1.DataQualityDetailGroupHeadingDiv, null, props.message),
            react_1.default.createElement(DataQualityStyles_1.DataQualityDetailGroupDiv, null, props.details.map(function (detail, index, _) { return (react_1.default.createElement(DataQualityDetail_1.DataQualityDetail, __assign({ key: props.keyPrefix + index.toString() }, detail, { linksDisabled: props.linksDisabled }))); }))));
    }
    return null;
}
exports.DataQualityDetailGroup = DataQualityDetailGroup;
//# sourceMappingURL=DataQualityDetailGroup.js.map